import { Box, Typography } from '@mui/material';
import { stepBadgeRingSrc } from '../../assets/referrals';

/** Figma 11147:1690 — step number with outer Ellipse 238 ring */
export default function ReferralStepBadge({ value }) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 40,
        height: 40,
        flexShrink: 0,
      }}
    >
     
      <Box
        component="img"
        src={stepBadgeRingSrc}
        alt=""
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          display: 'block',
          pointerEvents: 'none',
          mixBlendMode: 'screen',
        }}
      />

      <Typography
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'grid',
          placeItems: 'center',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 900,
          fontSize: 18,
          lineHeight: 1,
          color: '#fff',
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}
